import { Box, LinearProgress, Fade } from "@mui/material";

export const SCUILoadingLinear = (props: any) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Fade in={props.display} unmountOnExit>
        <LinearProgress />
      </Fade>
    </Box>
  );
};
